import { useMutation } from 'react-query';
import { API } from '../../CommonUtils/axiosWithDefaults';

export interface AddFileResult {
  fileName: string;
  isValid: boolean;
  errors: string[] | null;
}

interface AddFileParams {
  batchId: string;
  file: File;
}

const addFile = async ({ batchId, file }: AddFileParams): Promise<AddFileResult> => {
  const formData = new FormData();
  formData.append('file', file);

  return API.post(`/Adviser/PdfImport/AddFile?batchId=${encodeURIComponent(batchId)}`, formData);
};

export const usePdfAddFileMutation = () => {
  return useMutation(addFile);
};
